import { render, staticRenderFns } from "./weixinFollow.vue?vue&type=template&id=f7631f48&"
import script from "./weixinFollow.vue?vue&type=script&lang=js&"
export * from "./weixinFollow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports